<mat-icon class="wifi-icon" [svgIcon]="getIcon()"></mat-icon>
